import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

import Select from 'react-select';
import Clipboard from 'clipboard';

import Dialog from '../dialog';
import Events from '../../../../common/events';
import recurlyOptions from './recurlyOptions';
import globalconfig from '../../../../common/config';
import CognitoUtil from '../../../../aws/cognito/cognitoUtil';
import RavenDataStore from '../../../../common/ravenDataStore';



export class AddUserToAccountModal extends Component {

    constructor() {
    
        super();

        this.state = {
            ravenData: { allusers: [], accounts: [] },
            channel: '',
            channelid: -1,
            passwd: null,
            name: '',
            isOpen: false,
        };

        this.localState = {}

        this.dataStore = new RavenDataStore(this.dataChangeCallback);
        document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingMessage: 'Loading List' } }));



    }

    componentDidMount() {
        // Get all accounts
        this.dataStore.queryAccounts(this.props.stage);
        this.dataStore.queryUsers(this.props.stage);
        this.localState.stage = this.props.stage;

    }

    componentWillReceiveProps(nextProps) {
        this.accountList = this.state.ravenData.accounts.map(elem => {
                var obj = elem['account'];
                if(!obj)
                    return null;

                return { value : '' + obj['email'],
                    label: '' + obj['email'] + ' (' + obj['accountExternalId'] + ')',
                    id: obj['accountId'],
                    obj: obj,
                    isDisabled: obj['type'] !== 'FLEET',
                    disabled: obj['type'] !== 'FLEET'
                };

            });
        this.userList = this.state.ravenData.allusers.map(elem => {
                var obj = elem['user'];
                if(!obj)
                    return null;

                return { value : '' + obj['email'],
                    label: '' + obj['email'],
                    id: obj['email'],
                    obj: obj
                };

            });
    }

    componentDidUpdate() {

        var cb = new Clipboard('#copyPasswdBtn');

        if(this.props.stage !== this.localState.stage)
        {
            this.localState.stage = this.props.stage;
            this.dataStore.queryAccounts(this.props.stage);
        }

    }

    dataChangeCallback = (ravenData) => {
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        this.setState({ravenData: ravenData});
    }


    openModal = (e) => {
        this.setState({isOpen: true});
    }

    closeModal = (e) => {
        this.setState({isOpen: false});
    }

    onSelectAccountSearch = (id) => {

        var entry = this.state.ravenData.accounts.find((elem) => {
            if(!elem.account)
                return false;
            return elem.account.email === id.value;
        });

        if(entry)
        {
            this.setState({"account": id});
        }
    }

    onSelectUserSearch = (id) => {

        var entry = this.state.ravenData.allusers.find((elem) => {
            if(!elem.user)
                return false;
            return elem.user.email === id.value;
        });

        if(entry)
        {
            this.setState({"user": id});
        }
    }

    onRoleChange = (val) => {
        this.setState({roleid: val });
    }

    onChannelChange = (val) => {
        if(val.obj['channelId'] === 0)
        {
            this.setState({channel: val.obj['channelName'], channelid: val.obj['channelId'] });
        }
        else
        {
            this.setState({
                channel: val.obj['channelName'], 
                channelid: val.obj['channelId'], 
            });
        }

    }

    reportErrorToUser = (err) => {

        console.error(err);
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        var message = err && err.message ? err.message : "An unknown error occured while trying to create new user. Please contact support to resolve this issue."; //TODO LOC BILLING
        this.setState({ message: message, messageType: 'error' });
    }


    onUpdateUser = (e) => {
        e.preventDefault();
        var form = e.target;

        if(!this.state.account || !this.state.account.value)
        {
            return this.reportErrorToUser({message: "No Account Selected", messageType: 'error'}); 
        }

        if(!this.state.user)
        {
            return this.reportErrorToUser({message: "User not set", messageType: 'error'}); 
        }

        if(!this.state.roleid)
        {
            return this.reportErrorToUser({message: "Role not set", messageType: 'error'}); 
        }

        else
        {
            this.performUserUpdate(null);
        }
    }

    performUserUpdate = () => {
    
        document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE,
                { detail: { loadingMessage: 'Adding Fleet User to Account' } }));


        this.props.dataStore.updateFleetUser(this.props.stage, 
                this.state.account.value.toLowerCase(), this.state.user.value.toLowerCase(), 
                this.state.roleid.label,
                (json) => {
                // On Success
              document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));

              if(json.status !== "SUCCESS")
                {
                  document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
                  this.setState({message: "Error: " + json.errorMessage ? json.errorMessage : "Unknown" , messageType: 'error'});
                  console.error("Update User Error", json);
                  return;
                }

              this.setState({
                    messageType: 'success', message: 'Success'
                });
            
        }, (error) => {
                // On Fail
              document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
              this.setState({message: "Error: " + error, messageType: 'error'});
              console.error("Update User Error", error);
        });

    }

    doNothing = (e) => {
        e.preventDefault();
    }

    render() {

        // FIXME - probably not the most efficient.
        this.roles = [ { value : '0', label: 'ADMIN' },
                    { value : '1', label: 'VIEWER' },
                    { value : '-1', label: 'REMOVE' },
                ];

        var errorMessage = null;

        if(this.state.messageType === 'success')
        {
            errorMessage = this.state.message ?
                <p className="success-message"><i className="material-icons">check_circle_outline</i>{this.state.message}</p> :
                null;
        }
        else
        {
            errorMessage = this.state.message ?
                <p className="error-message"><i className="material-icons">error_outline</i>{this.state.message}</p> :
                null;
        }

        return (
            <Dialog
                size="medium"
                className="test"
                label={this.props.title}
                isOpen={this.props.isOpen}
                onClose={this.props.onClose}
                onAfterOpen={this.reinitializeRecurly}
                >

                <div className="container-fluid form-card">

                    <div className="row">

                        <div className="col-12 content-group">

                            <h2>Add User to Account</h2>

                            <div className="row">
                                <div className="col-2">
                                    <label htmlFor="stage">Stage</label>
                                </div>
                                <div className="col-4">{this.props.stage} </div>
                                <div className="col-2">
                                    <label htmlFor="role">Role</label>
                                </div>
                                <div className="col-2">
                                    <Select id="role"
                                    placeholder="Role..."
                                    searchable={true}
                                    value={this.state.roleid}
                                    options={this.roles}
                                    name="channel"
                                    onChange={this.onRoleChange}
                                    clearable={false} />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-2">
                                    <label htmlFor="account">Existing Account</label>
                                </div>
                                <div className="col-10" >
                                    <Select id="ravenSearch"
                                        placeholder="Search..."
                                        searchable={true}
                                        options={this.accountList}
                                        value={this.state.account}
                                        name="ravenSearch"
                                        filterOption={(option, filter) => {
                                            if(!option)
                                                return false;
                                            // Search: ravenid, raven unit id, email, raven enclosure id 
                                            else if(option.obj['accountId'] && option.obj['accountId'].toString().includes(filter))
                                                return true;
                                            else if(option.obj['email'] && option.obj['email'].toString().includes(filter))
                                                return true;
                                            return false;
                                        }}
                                        onChange={this.onSelectAccountSearch}
                                        clearable={false} />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-2">
                                    <label htmlFor="user">Existing User</label>
                                </div>
                                <div className="col-10" >
                                    <Select id="userSearch"
                                        placeholder="Search..."
                                        searchable={true}
                                        options={this.userList}
                                        value={this.state.user}
                                        name="ravenSearch"
                                        filterOption={(option, filter) => {
                                            if(!option)
                                                return false;
                                            // Search: ravenid, raven unit id, email, raven enclosure id 
                                            else if(option.obj['email'] && option.obj['email'].toString().includes(filter))
                                                return true;
                                            return false;
                                        }}
                                        onChange={this.onSelectUserSearch}
                                        clearable={false} />
                                </div>
                            </div>

                            <form className="row" onSubmit={this.onUpdateUser}>

                                <div className="col-12">
                                    {this.state.user && this.state.account && this.state.roleid ?
                                        <button>Update User</button> :
                                        <button disabled>Update User</button>
                                    }
                                    {errorMessage}
                                </div>
                            </form>


                        </div>
                    </div>
                    
                    </div>
            </Dialog>
        );
    }

}

export default class AddExistingUserToFleet extends Component {

    constructor() {
        super();

        this.state = {
            modalIsOpen: false,
        }
    }

    openModal = (e) => {
        e.preventDefault();

        this.setState({modalIsOpen: true});
    }

    closeModal = (e) => {
        this.setState({modalIsOpen: false});
    }

    render()
    {
        var title = "Create New Fleet User (" + this.props.stage + ")"; 


        return ( 
            <div className="3rdparty d-inline-block">
                <a href="#!" onClick={this.openModal}>
                    <img src="/images/baseline_person_add_white_24dp.png" alt="New Fleet User"/>
                </a>
                <AddUserToAccountModal title={title} isOpen={this.state.modalIsOpen} 
                        stage={this.props.stage}
                        onClose={() => {this.setState({modalIsOpen: false})}} 
                />
            </div>
        );

    }
}

